<template>
	<div>
    <div v-if="show" style="width: 100%;height: 100%;z-index: 999;background-color: rgba(90,90, 54, 0.5);position: absolute;">
      <div class="tc">
        <div style="display: flex;margin-top: 10px;">
          <label>退款数量：</label>
          <input v-model="number"  type="number" maxlength="1"/>
        </div>
        <div style="display: flex;">
          <button class="btn ls" @click="cancle()">取消</button>
          <button class="btn ls" @click="tuikuansend()">确定</button>
        </div>
      </div>
    </div>
		<div class="list-btn">
			<Button type="primary" @click="ret">返回</Button>
		</div>
    <div style="margin-left: 30px;margin-bottom: 4px;" v-if="clientAddress">
      <label style="margin-right: 20px;font-size: 13px;">配送费：{{(psf/100).toFixed(2)}}</label>
      <Button v-if="psftk!=0" type="primary" disabled="disabled">配送费已退款</Button>
      <Button v-else type="primary" @click="tkpsf">退款配送费</Button>
    </div>
		<Table border ref="selection" :columns="columns12" :data="data6" @on-selection-change="selection" :loading="loading">

			<template slot-scope="{ row, index }" slot="action">
        <Button v-if="row.refundMoney == row.sellPrice*row.number" disabled="disabled" type="primary" size="small" style="margin-right: 5px">已退款</Button>
				<Button v-else type="primary" size="small" style="margin-right: 5px" @click="tuikuan(row)">退款</Button>
			</template>
		</Table>
		<div class="my-page">
			<page :total="total" @updatePage="updatePage" @updateSize="updateSize"></page>
		</div>
  </div>

</template>
<script>
	import http from '@/http/http.js'
	import page from '@/components/comm/page.vue'
	export default {
		data() {
			return {
        show:false,
				loading:false,
        clientAddress:"",
        number:"",
				kaishi:'',
				jieshu:'',
				//设备列表
        psf:'',
        psftk:"",
				macs: [
						/* {
							value: '1',
							label: 'New York'
						} */
					],
				//加盟商列表
				alliances: [
						/* {
							value: '1',
							label: 'New York'
						} */
					],
				//总页数
				total: 100,
				columns12: [

					{
						title: '订单id',
						key: 'orderId'
					},
					{
						title: '商品名称',
						key: 'commodityName'
					},{
						title: '商品类型',
						key: 'commodityTypeName'
					},
					{
						title: '应出货数量',
						key: 'number'
					},
					{
						title: '实际出货数量',
						key: 'shipmentNUmber'
					},
					{
						title: '单价',
						key: 'sellPrice',
						render: (h, params) => {
							return h("div",params.row.sellPrice/100)
						}
					},
					{
						title: '总价',
						key: 'sellPrices',
						render: (h, params) => {
							return h("div",(params.row.sellPrice/100*params.row.number).toFixed(2))
						}
					},{
						title: '退款金额',
						key: 'refundMoney',
						render: (h, params) => {
              if(params.row.refundMoney==0||!params.row.refundMoney){
                return h("div",params.row.refundMoney)
              }else{
                return h("div",(params.row.refundMoney/100).toFixed(2))
              }
						}
					},{
						title: '操作',
						slot: 'action',
						width: 160,
						align: 'center'
					}

					// {
					// 	title: '抽成比例',
					// 	key: 'rake',
					// 	render: (h, params) => {
					// 		return h("div",params.row.rake/10000)
					// 	}
					// },
					// {
					// 	title: '抽成金额',
					// 	key: 'sellPrice',
					// 	render: (h, params) => {
					// 		return h("div",params.row.sellPrice/100*params.row.number*params.row.rake/10000)
					// 	}
					// },
					// {
					// 	title: '出货状态',
					// 	key: 'purchasingPrice',
					// 	render: (h, params) => {
					// 		if(params.row.number==params.row.shipmentNUmber){
					// 			return h("div","正常")
					// 		}else{
					// 			return h("div","异常")
					// 		}

					// 	}
					// },

				],
				data6: [
					/* {
					id: '1',
					name: 'XXX机器人',
					address: '渝北区泰山大道东段',
					isRefrigerate: '冷藏',
					startUsing: '启用',
					state: '正常',
					isStockout: '正常',
					useOperOperator: "XXXX",
					createdTime: '2010-10-10'
				} */
				],
				query: {
					page: '0',
					size: '10',
					id:'',
				},
        finDetailsId:"",
        realnumber:"",
		sellri:"",
		sellris:"",
		refundmo:""
			}
		},
		methods: {
      cancle(){
        this.show=false
      },
      tuikuan(item){
        this.show=true
        this.finDetailsId=item.id
        this.realnumber=item.number
		this.sellri = item.sellPrice
		this.sellris = item.sellPrices
		this.refundmo = item.refundMoney
      },
      tuikuansend(){
		  console.log(this.refundmo/this.sellri)
        if(this.number<=0||this.number>this.realnumber||this.refundmo !=""&this.refundmo/this.sellri<this.number&this.number>this.realnumber-this.refundmo/this.sellri){
          this.$Message.error("输入正确的退款数量")
          return false
        }
		//这里的判断条件有待验证，判断结果有待测试测试
		/*if(this.number <= 0 || this.number > this.realnumber || this.number > this.realnumber-this.refundmo/this.sellri) {
			this.$Message.error("输入正确的退款数量")
			return false
		}*/
        let _this = this
        let obj={
          refundType:'sp',
          finId:this.query.id,
          finDetailsId:this.finDetailsId,
          number:this.number,
        }
        http.http({
            //这里是你自己的请求方式、url和data参数
            method: 'post',
            url: http.url + '/client/pay/refund1',
            data: obj,
            _this:this,
        	success: function(data) {
        		if(data.code==200){
              _this.$Message.success("退款成功")
              _this.show=false
              _this.ajaxPage()
			  // location.reload()
            }
        	}
          })
      },
      tkpsf(){
        let _this = this
        let obj={
          refundType:'psf',
          finId:this.query.id
        }
        http.http({
            //这里是你自己的请求方式、url和data参数
            method: 'post',
            url: http.url + '/client/pay/refund1',
            data: obj,
            _this:this,
        	success: function(data) {
        		if(data.code==200){
              _this.$Message.success("退款成功")
              _this.psftk=_this.psf
            }
        	}
          })
      },
			ret() { //返回上一页
				this.$router.go(-1)
			},

			//查询条件
			updatePage(page) { //页码改变的回调，返回改变后的页码
				this.query.page = page - 1
				this.ajaxPage()
			},
			updateSize(size) { //切换每页条数时的回调，返回切换后的每页条数
				this.query.size = size
				this.ajaxPage()
			},
			ajaxPage() {
				this.loading = true
				let _this=this
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/fin/report/comm/queryOrderDetails',
				    data: _this.query,
					_this: _this,
					success: function(data) {
						_this.total = data.queryOrderDetails.length
						_this.data6 = data.queryOrderDetails

						_this.loading = false
					}
				    //假设后台需要的是表单数据这里你就可以更改
				  })

			},


		},
		components: {
			page
		},
		created() {
			let _this=this
			_this.query.id=_this.$route.query.orderId
			_this.psf=_this.$route.query.distributionMoney
			_this.psftk=_this.$route.query.distributionRefundMoney
			_this.clientAddress=_this.$route.query.clientAddress
			this.ajaxPage()
		},
		beforeRouteLeave(to, from, next) {
			this.$destroy(); //销毁B的实例
			from.meta.keepAlive=false;
			to.meta.keepAlive=true;
			next()
		},
	}
</script>
<style scoped="scoped" lang="less">
  .ls{
    background-color: #007AFF;
    border: none;
    padding: 4px 8px 4px 8px;
    color: white;
    border-radius: 5px;
  }
  .tc{
    height: auto;
    display: flex;
    flex-direction: column;
    width: 30%;
    background-color: white;
    justify-content: space-around;
    align-items: center;
    margin: auto;
    margin-top: 10%;
  }
	.list-btn {
		margin-bottom: 20px;
	}

	.delete {
		/* background-color: red;
		color: #333333; */
	}

	.my-page {
		display: flex;
		justify-content: flex-end;
		margin-top: 20px;
	}

	.tongji {
		width: 100%;
		display: flex;
		margin:10px;
		.item{
		    margin: 0px 20px 0px 20px;
			display: flex;
			font-size: 20px;
		}
	}

	.checkbox {
		display: flex;
		justify-content: flex-end;
	}

	span {
		color: #007AFF;
	}

	.btn {
		margin: 20px;
		display: flex;
		.tj{
			display: flex;
			align-items: center;
		}
		.time{
			display: flex;
			.time-xz{
				display: flex;
			    align-items: center;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/jm/platform/finance/allianceOrderDetails.vue